import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'

import { CTAButton } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { HouseCarouselSkeletonLoader } from '@f-fertighaus/applications/Next/components/common/HouseCarouselSkeletonLoader'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import {
  CTAContainer,
  SimilarHousesContainer
} from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/SimilarHouses'

export const SimilarHousesSectionLoading = () => {
  const { state: houseDetailData } = useHouseDetail()

  return (
    <SimilarHousesContainer>
      <Box sx={{ pb: 2 }}>
        <Typography component='h2'>
          <Typography variant='mediumTitle' component='span' display='block'>
            {t('houseDetailPage.similar-houses.title', {
              houseName: houseDetailData.name
            })}
          </Typography>
          <Typography component='span' variant='body2' display='block'>
            {t('houseDetailPage.similar-houses.for', {
              name: houseDetailData.name
            })}
          </Typography>
        </Typography>
      </Box>
      <HouseCarouselSkeletonLoader />
      <CTAContainer>
        <Box className='placeholder'>
          <Skeleton variant='rectangular' width='235px' height={48} />
        </Box>
      </CTAContainer>
    </SimilarHousesContainer>
  )
}

export const SimilarHousesSectionEmpty = () => {
  const { state: houseDetailData } = useHouseDetail()

  return (
    <SimilarHousesContainer>
      <Box sx={{ pb: 2 }}>
        <Typography component='h2'>
          <Typography variant='mediumTitle' component='span' display='block'>
            {t('houseDetailPage.similar-houses.title', {
              houseName: houseDetailData.name
            })}
          </Typography>
          <Typography component='span' variant='body2' display='block'>
            {t('houseDetailPage.similar-houses.for', {
              name: houseDetailData.name
            })}
          </Typography>
        </Typography>
      </Box>
      <Box className='[ f-d-flc f-fl-al-ce f-fl-jc-ce ]' height={335}>
        Leider können wir kein ähnliches Haus finden.
      </Box>
      <CTAContainer>
        <CTAButton variant='contained' color='primary' disabled>
          Weitere Häuser anzeigen
        </CTAButton>
      </CTAContainer>
    </SimilarHousesContainer>
  )
}
